import React, { Component } from "react"
import { connect } from 'react-redux'

import {msg} from '../Notifications/MsgBox';

class UploadImageButton extends Component {

    constructor(props) {
        super(props)
        this.state = {
        };
    }

    componentDidMount() {
        
    }

    componentWillReceiveProps(nextProps) {

    }

    openUploadModal() {
        const { modalId,transaction_no,file_category,defaultFileName } = this.props;

        if(transaction_no)
        {
            window.$(`#filename_${file_category}`).val(defaultFileName);
            window.$(`#file_${file_category}`).val('');
            window.$(`#${modalId}`).modal('show');
        }
        else{
            msg.error("กรุณาบันทึกรายการก่อน อัพโหลดไฟล์")
        }

    }



    render() {
        const { viewMode ,id } = this.props;
        if (viewMode)
        {
                return (                    
                <>      
                    {/* <a id={id} href="#main">  <i className="icon btn-save-order" /></a>          */}
                    
                </>)
        }
        else{
                return (
                 <>      
                    <a id={id}  onClick={() => this.openUploadModal()}>  <i className="icon btn-save-order" /></a>         
                 </>
                )
                }
        }
        }

export default UploadImageButton